import { memo } from 'react';
import type { ThemeSpaces } from '@frameio/vapor';
import { LEXICAL_SEARCH_TYPE } from '../../../../shared/constants';
import type { TrackTabSelected } from '../../../../shared/contexts/SearchAnalyticsContext/types';
import type { SearchMode } from '../../../../shared/types';
import type { QuickSearchResultTypes } from '../../shared/QuickSearchResultTypes';
import { AssetListItem } from './AssetListItem';
import { ProjectListItem } from './ProjectListItem';

type Props = {
  isActive?: boolean;
  isCompact?: boolean;
  itemId: string;
  itemPosition: number;
  itemType: QuickSearchResultTypes;
  paddingInlineEnd?: ThemeSpaces;
  searchMode?: SearchMode;
  searchQuery?: string;
  tabSelected?: TrackTabSelected;
};

export const QuickSearchListItem = memo(
  ({
    isActive,
    isCompact = false,
    itemId,
    itemPosition,
    itemType,
    paddingInlineEnd,
    searchMode = LEXICAL_SEARCH_TYPE,
    searchQuery = '',
    tabSelected,
  }: Props) => {
    switch (itemType) {
      case 'AssetResult':
        return (
          <AssetListItem
            assetId={itemId}
            isActive={isActive}
            isCompact={isCompact}
            itemPosition={itemPosition}
            paddingInlineEnd={paddingInlineEnd}
            searchMode={searchMode}
            searchQuery={searchQuery}
            tabSelected={tabSelected}
          />
        );
      case 'ProjectResult':
        return (
          <ProjectListItem
            isActive={isActive}
            isCompact={isCompact}
            itemPosition={itemPosition}
            paddingInlineEnd={paddingInlineEnd}
            projectId={itemId}
            searchMode={searchMode}
            searchQuery={searchQuery}
            tabSelected={tabSelected}
          />
        );
      default:
        return null;
    }
  }
);

QuickSearchListItem.displayName = 'QuickSearchListItem';
